






























































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SelectOption, SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { Prop } from 'vue-property-decorator';
import { DateTimePickerConfig, SwDatetimePicker } from '@sonicwall/unified-ui-framework/src/shared/sw-datetime-picker';
import { SwForm, SwFormRow,  SwFormRowError } from '@libs-uuif/shared/sw-form';
import { required } from 'vuelidate/lib/validators';

const cssPrefix = 'tax-info';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwCheckbox,
    SwDatetimePicker,
    SwForm,
    SwFormRow,
    SwFormRowError,
  },
  validations: {
    state: { required },
    fedralTaxId: { required },
    certificateId: { required },
  },
})
export default class TaxinfoModal extends SwExtendedVue {
  cssPrefix = cssPrefix;
  display2 = true;
  modalTitle = '';
  @Prop({ required :  true })
  usStates : any;
  @Prop({ required :  true })
  orgId : any;
  @Prop({ required :  true })
  fedId : any;
  fedralTaxId : any = '';
  states : SelectOption[] = [];
  state :  any = '';
  isSubmitted : boolean = false;
  certificateId : any = '';
  singlePickerConfig: DateTimePickerConfig = {
    placeholder: 'Expiry Date',
    // dateFormat: 'MM/DD/YYYY',
    onDayClick: this.onDayClick2,
  };
  dateValue = '';

  created() {
    this.states = this.usStates;
    // this.state = this.states[0].id;
  }

  onDayClick2() {
    console.warn('sas');
  }
  closeDialog() {
    this.$emit('close-modal');
  }
  submit() {
    if (this.checkInputValidation()) {
      if (this.dateValue !== '') {
        const requestDisplay = {
          state: this.states.filter((ele : any) => ele.id === this.state)[0].label,
          stateCode: this.states.filter((ele : any) => ele.id === this.state)[0].id,
          expiryDate: this.dateValue,
          certificateId: this.certificateId,
          OrgId: this.orgId,
        };
        const request = {
          state: this.states.filter((ele : any) => ele.id === this.state)[0].id,
          taxId: this.fedralTaxId === '' ? this.fedId : this.fedralTaxId,
          expDate: this.dateValue,
          certId: this.certificateId,
          orgId: this.orgId,
        };
        this.$store.commit('startLoading');
        this.$store.dispatch('SnbProfileStoreModule/addTaxInfo', request)
        .then((resp) => {
          if (resp.operationStatus === 'OK') {
            this.$emit('success', requestDisplay);
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
            this.$emit('close-modal');
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
            this.$emit('close-modal');
          }
          this.$store.commit('stopLoading');
        });
      }
    }
  }

  checkInputValidation(): boolean {
    this.$v!.state!.$touch();
    this.$v!.fedralTaxId!.$touch();
    this.$v!.certificateId!.$touch();
    if (!this.$v!.state!.$invalid && !this.$v!.certificateId!.$invalid &&
        !this.$v!.fedralTaxId!.$invalid &&
        (this.state != null && this.state !== '' && this.state !== 'select') &&
        (this.certificateId != null && this.certificateId !== '') &&
        (this.fedralTaxId !== null && this.fedralTaxId !== '')) {
      return true;
    }
    return false;
  }
  cancel() {
    this.$emit('close-modal');
  }
}
